import React, {useState} from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import { Typography } from "@material-ui/core";
import Button from "../../../../../../ui/Button";
import Progress from "../../../../../../ui/Progress";
import CardOrganization from "../../../../../../ui/CardOrganization";
import { getMasterClassCard } from "../../store/actions";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import IconButton from "@material-ui/core/IconButton";

import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";
import ProgramImage from "../../../MyOPMod/components/ProgramImage";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import {SmallStateIcon, StateTextColor} from "../StateStyles";
import CardInfoField from "../../../../../../ui/CardInfoField";
import {format, parseISO} from "date-fns";
import ru from "date-fns/locale/ru";

const drawerWidth = 280;

const useStyles = makeStyles(theme => ({
  title: {
    flexGrow: 1
  },
  hide: {
    display: "none"
  },
  devider: {
    marginTop: 16,
    display: "flex",
    alignItems: "flex-start",
    borderBottom: "1px dashed #CACCD1",
    fontWeight: 500
  },
  block: {
    marginTop: 16
  },
  typo: {
    fontSize: 16,
    lineHeight: "24px"
  },
  stateBlock: {
    marginTop: 16,
    marginBottom: 8,
    height: 20,
    display: "block",
    width: "240px",
    boxSizing: "border-box"
  },
  more: {
    marginTop: 24,
    marginBottom: 90,
    display: "flex",
    justifyContent: "center"
  },
  cardTitle: {
    padding: "8px 0",
    borderBottom: "1px dashed #CACCD1"
  },
  progress: {
    display: "flex",
    justifyContent: "center"
  },
  drawerOpen: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: 1000
    /*[theme.breakpoints.down("md")]: {
      position: "fixed"
    }*/
  },
  drawerClosed: {
    width: 0
  },
  drawerPaper: {
    width: drawerWidth,
    boxSizing: "border-box",
    top: 65
  },
  drawerPaperContent: {
    boxSizing: "border-box",
    padding: 20
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-start"
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginRight: -drawerWidth
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginRight: 0
  },
  closeButton: {
    position: "absolute",
    opacity: 0.5,
    height: 24,
    textAlign: "left",
    display: "flex",
    alignItems: "flex-start",
    "& .MuiIconButton-root": {
      padding: 0
    }
  },
  btnDrawer: {
    fontSize: 12,
    paddingRight: 6,
    paddingLeft: 6,
    minWidth: 110
  },
  programName: {
    fontSize: 14,
    fontWeight: 600
  },
  dateRange: {
    marginTop: 16,
    "& span": {
      color: "#00334E",
      marginBottom: 10,
      marginLeft: 4,
      marginRight: 4,
      display: "inline-block",
      "vertical-align": "middle"
    },
    "& .MuiSvgIcon-root": {
      fill: "#00334E",
      display: "inline-block"
    }
  }
}));

const formatDate = date =>
  date ? format(parseISO(date), "dd.MM.yyyy", { locale: ru }) : null;

const MasterClassDrawer = ({
                             open,
                             mcId,
                             getMasterClassCard,
                             masterClassCard,
                             history,
                             hideLink,
                             handleDrawerClose
                           }) => {
  const classes = useStyles();
  const [card, setCard] = useState(null);

  React.useEffect(() => {
    if (mcId !== -1) {
      setCard(null);
      getMasterClassCard(mcId);
    }
  }, [mcId]);

  React.useEffect(() => {
    //console.log(masterClassCard);
    setCard(masterClassCard);
  }, [masterClassCard]);

  const onLinkClick = () => {
    history.push(`/work/app/manage/resources/master-class/${mcId}`);
  };

  return (
    <Drawer
      className={open ? classes.drawerOpen : classes.drawerClosed}
      variant="persistent"
      anchor="right"
      open={open}
      classes={{
        paper: classes.drawerPaper
      }}
    >
      <div>
        {!hideLink &&
          <div className={classes.closeButton}>
            <IconButton onClick={handleDrawerClose}>
              <ChevronRightIcon />
            </IconButton>
          </div>
        }
        {card ? (
          <div className={classes.drawerPaperContent}>
              <ProgramImage fileId={card.logo} />
              <div className={classes.cardTitle}>
                <Typography className={classes.typo} align="center">
                  {card.name}
                </Typography>
                <div className={classes.stateBlock}>
                  <Grid container direction="row" justify="space-between" alignItems="center">
                    <Grid item xs={5}>
                      <Chip color="primary"
                            style={{ backgroundColor: "rgba(48,73,103,0.8)"}}
                            size="small"
                            icon={<AccessTimeIcon />}
                            label={`${card.duration || 0} ч.`}/>
                    </Grid>
                    <Grid item xs={7}>
                      <Chip color="primary"
                            style={{ backgroundColor: StateTextColor(card.statusId)}}
                            size="small"
                            icon={SmallStateIcon(card.statusId, "svgIcon svgFillWhite")}
                            label={card.statusName}/>
                    </Grid>
                  </Grid>
                </div>
              </div>
            <CardInfoField field="Дата начала:" value={card.date ? formatDate(card.date) : 'не указана'} />
            <CardInfoField field="Вместимость:" value={card.capacity || 'не указана'} />
            <CardInfoField field="Обучающихся:" value={card.count || 0} />
            <div style={{ "marginTop": 16, "fontSize": 12 }}>
              <Typography style={{ "display": "block"}}
                          variant="caption"
                          color="textSecondary">
                Программа:
              </Typography>
              <Typography variant="caption">
                {card.program ? ( card.program.code ? card.program.code + ' | ' + card.program.name : card.program.name) : 'не указана'}
              </Typography>
            </div>
            <div className={classes.devider}></div>

            {card.organization && (
              <>
                <div className={classes.block}>
                  <Typography
                    style={{ display: "block", marginBottom: 8 }}
                    variant="caption"
                    color="textSecondary"
                  >
                    Подрядчик
                  </Typography>
                  <div style={{ display: "block" }}>
                    <CardOrganization
                      logo={card.organization.logo}
                      orgName={card.organization.name}
                    />
                  </div>
                </div>
                <div className={classes.devider}></div>
              </>
            )}

            <div className={classes.more}>
              {!hideLink && <Button onClick={onLinkClick}>Подробнее</Button>}
            </div>
          </div>
        ) : (
          <div className={classes.progress}>
            <Progress />
          </div>
        )}
      </div>
    </Drawer>
  )
}

const mapStateToProps = state => ({
  masterClassCard: state.masterClasses.masterClassCard
});

const mapDispatchToProps = dispatch => ({
  getMasterClassCard: id => dispatch(getMasterClassCard(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MasterClassDrawer));
